import { get, post, postFormData, deleteMethod } from '../base/index';

export default {
    getCourseStoreProducts: (params) => {
        return get(`${process.env.REACT_APP_URL_BASE}/course-store-products/`, { params });
    },
    registerCourseStoreProduct: (body) => {
        return post(`${process.env.REACT_APP_URL_BASE}/course-store-products/`, body);
    },
    executeAppStoreStep: (body) => {
        return post(`${process.env.REACT_APP_URL_BASE}/course-app-store-steps/`, body);
    },
    getAppStoreStatus: (courseId) => {
        return get(`${process.env.REACT_APP_URL_BASE}/course-app-store-status/`, { params: { course_id: courseId } });
    },
    executeAppStoreScreenshotStep: (courseId, file) => {
        const formData = new FormData();
        formData.append('course_id', courseId);
        formData.append('step', 'UPLOAD_SCREENSHOT');
        formData.append('screenshot', file);
        return postFormData(`${process.env.REACT_APP_URL_BASE}/course-app-store-steps/`, formData);
    },
    deleteAppStoreScreenshot: (courseId) => {
        return deleteMethod(`${process.env.REACT_APP_URL_BASE}/course-app-store-steps/`, { params: { course_id: courseId } });
    },
    lookupAppStoreIAP: (courseId) => {
        return get(`${process.env.REACT_APP_URL_BASE}/course-app-store-lookup/`, { params: { course_id: courseId } });
    },
};
